<template>
  <div class="article-box">
    <h5 class="article_title">新手指引</h5>
    <hr>
    <div class="article_content" v-html="data">
     <!-- <p class="assist">
        第一步：点击
        <span class="red">"用户中心"</span>
      </p>
      <p>
        <img class="imgassist" src="../assets/img/2668b8bd5467dcc467cae32da1d9e4d0.jpg">
      </p>
      <p class="assist">
        第二步：点击
        <span class="red">"在线注册"</span>分别填写
        <span class="red">"手机号"</span>—
        <span class="red">"验证码"</span>-
        <span class="red">"手机验证码"</span>-
        <span class="red">"密码"</span>-
        <span class="red">"推荐人手机码"</span>(可填可不填)
      </p>
      <p>
        <img class="imgassist" src="../assets/img/03013a1bd16ca6cee645f9d577aed28d.jpg">
      </p>
      <p class="assist">
        第三步：点击
        <span class="red">"用户登录"</span>&nbsp; &nbsp;分别输入
        <span class="red">"手机号"</span>—
        <span class="red">"密码"</span>-
        <span class="red">"验证码"</span>—点击进入
      </p>
      <p>
        <img class="imgassist" src="../assets/img/e04575f3fc99a21aa89236ceccb0038f.jpg" title="3.jpg" alt="3.jpg">
      </p>
      <p class="assist">
        第四步:点击
        <span class="red">"用户中心"</span>—选择
        <span class="red">"充值提现"</span>-
        <span class="red">"充值金额"</span>-填写
        <span class="red">"相关信息"</span>—点击
        <span class="red">"确定"</span>提交
      </p>
      <p>
        <img class="imgassist" src="../assets/img/6480ebf625bea104c077da7df8b530c0.png" title="4.png" alt="4.png">
      </p>
      <p class="assist">
        第五步：选择您的配资玩法—直接点击
        <span class="red">"VIP配资"</span>\
        <span class="red">"按周配资"</span>\
        <span class="red">"按月配资"</span>\
        <span class="red">"按周配资"</span>\
        <span class="red">"免息配资"</span>\(针对新玩家),我们以
        <span class="red">"按天配资"</span>
      </p>
      <p>
        <img class="imgassist" src="../assets/img/7ecd11654b0668c3b226e46ce1b22bf8.png" title="4.png" alt="4.png">
      </p>
      <p class="assist">
        第六步：提交申请之后,我们可以点击
        <span class="red">"用户中心"</span>—点击
        <span class="red">"配资账户"</span>—进行
        <span class="red">"实盘交易"</span>
      </p>
      <p>
        <img class="imgassist" src="../assets/img/fe99d2e7bcde49b997f9612ffce66796.png">
      </p>
      <p class="assist">
        第七步：点击实盘交易后进入实盘操作—输入
        <span class="red">股票代码</span>—选择
        <span class="red">购买信息</span>—点击
        <span class="red">确认交易</span>
      </p>
      <p>
        <img class="imgassist" src="../assets/img/d03b1a26e4750181442c12435b7bf27d.png">
        <img class="imgassist" src="../assets/img/9dd8d903cefcdd51713b56aad03a595e.png">
        <img class="imgassist" src="../assets/img/c35fcb06274c40de39570536b40f539f.png">
        <img class="imgassist" src="../assets/img/fcd72b1262d7f5d833f5faf51fef1cb1.png">
      </p>
      <p class="assist">
        第八步:实盘交易
        <span class="red">"确认"</span>后,可以到
        <span class="red">"用户中心"</span>—
        <span class="red">"通知消息"</span>里面进行查询。
      </p>
      <p>
        <img class="imgassist" src="../assets/img/db25434495121d5bd71fd34fc07f6d9e.png">
        <img class="imgassist" src="../assets/img/703b2af2a1cb3420084f12a3a9f2fa31.png">
        <img class="imgassist" src="../assets/img/a79bb6cd1249580bc71bbec74615347d.png">
        <img class="imgassist" src="../assets/img/4660cebb1d54aa2dc44ca83c817f0e1f.png">
      </p>
      <p class="assist">
        第九步：完成后到
        <span class="red">"用户中心"</span>—
        <span class="red">"配资账户"</span>—
        <span class="red">"账户交割"</span>进行，可以直接
        <span class="red">提现</span>或者是继续其他配资。
      </p>
      <p>
        <img class="imgassist" src="../assets/img/5b9715747699f447fbd336786ccd4d1d.png">
        <img class="imgassist" src="../assets/img/602536206a051bd1e52068d144b47b79.png">
        <img class="imgassist" src="../assets/img/158030c70d91a084da7520b5abe51165.png">
      </p>
      <p class="assist">
        第十步：提现：提现前您需要先到
        <span class="red">"用户中心"</span>—
        <span class="red">"实名认证"</span>—认证完即可提现
      </p>
      <p>
        <img class="imgassist" src="../assets/img/73db76886931352e4dd202fd55da5bd2.png">
        <img class="imgassist" src="../assets/img/9d040ef8371cd9b3862b9a16490ac686.png">
        <img class="imgassist" src="../assets/img/8fcc8f73c4f06758d74735008388f3ca.png">
      </p>
      <br>
      <p class="assist">
        <span class="red">永华证券官网:</span>www.hk9999z.com
        <br><br>
        <span class="red">永华证券平台:</span>www.hk9999z.com
        <br><br>
        <span class="red">永华证券客服QQ:</span>4006593678
        <br><br>
        <span class="red">永华证券服务热线:</span>4006593678
      </p>
      <br>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "helpguidelines",
    data(){
      return{
        data:''
      }
    },
    methods:{
      getData(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'protocol',
              'type': 12,
            }
          })  .then(res => {
          let resData = res.data;
          if (res.data.code == 1) {
            that.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
      }
    },
    mounted() {
      this.getData();
    }
  }
</script>

<style scoped>
  .article_title {
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>>img{
    width: 100% !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/helpguidelines.vue